import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
import { computed } from '../../../adapter-vue';
import TUIChatEngine from '@tencentcloud/chat-uikit-engine';
export default /*@__PURE__*/_defineComponent({
  __name: 'message-call-group',
  props: {
    message: {
      default: () => ({})
    },
    signalingInfo: {
      default: () => ({})
    },
    customContent: {
      default: () => ({})
    },
    blinkMessageIDList: {
      default: () => []
    }
  },
  setup(__props) {
    var props = __props;
    var TYPES = TUIChatEngine.TYPES;
    var isCallMessage = computed(() => !!props.signalingInfo);
    var conversationType = computed(() => {
      var _props$message;
      return (_props$message = props.message) === null || _props$message === void 0 ? void 0 : _props$message.conversationType;
    });
    var custom = computed(() => {
      var _props$customContent;
      return (_props$customContent = props.customContent) === null || _props$customContent === void 0 ? void 0 : _props$customContent.custom;
    });
    var isBlink = computed(() => {
      var _props$message2;
      if ((_props$message2 = props.message) !== null && _props$message2 !== void 0 && _props$message2.ID) {
        var _props$blinkMessageID;
        return (_props$blinkMessageID = props.blinkMessageIDList) === null || _props$blinkMessageID === void 0 ? void 0 : _props$blinkMessageID.includes(props.message.ID);
      }
      return false;
    });
    return (_ctx, _cache) => {
      return _unref(isCallMessage) && _unref(conversationType) === _unref(TYPES).CONV_GROUP ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({
          'blink-text': _unref(isBlink)
        })
      }, _toDisplayString(_unref(custom)), 3)) : _createCommentVNode("", true);
    };
  }
});